/**
 * Table of Contents Module
 * Automatically generates a TOC from h2 and h3 headings in blog posts
 */

export function initTableOfContents() {
  // Only run on blog post pages
  const article = document.querySelector('article .prose');
  const sidebar = document.querySelector('.post-sidebar');
  if (!article || !sidebar) return;

  // Find all h2 and h3 headings
  const headings = article.querySelectorAll('h2, h3');
  if (headings.length < 3) return; // Only show TOC if there are at least 3 headings

  // Generate IDs for headings if they don't have them
  headings.forEach((heading, index) => {
    if (!heading.id) {
      const text = heading.textContent.trim();
      const id = text
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-');
      heading.id = id || `heading-${index}`;
    }
  });

  // Create TOC container
  const toc = document.createElement('nav');
  toc.className = 'table-of-contents';
  toc.setAttribute('aria-label', 'Table of Contents');

  // Create TOC title
  const title = document.createElement('h2');
  title.textContent = 'Table of Contents';
  title.className = 'toc-title';
  toc.appendChild(title);

  // Create TOC list
  const list = document.createElement('ul');
  list.className = 'toc-list';

  headings.forEach((heading) => {
    const li = document.createElement('li');
    li.className = `toc-item toc-${heading.tagName.toLowerCase()}`;

    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    link.className = 'toc-link';

    // Smooth scroll on click
    link.addEventListener('click', (e) => {
      e.preventDefault();
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Update URL without triggering a jump
      history.pushState(null, '', `#${heading.id}`);
    });

    li.appendChild(link);
    list.appendChild(li);
  });

  toc.appendChild(list);

  // Append TOC to sidebar
  sidebar.appendChild(toc);

  // Highlight current section on scroll
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id;
        const link = toc.querySelector(`a[href="#${id}"]`);
        if (link) {
          if (entry.isIntersecting) {
            // Remove active class from all links
            toc.querySelectorAll('.toc-link').forEach((l) => l.classList.remove('active'));
            // Add active class to current link
            link.classList.add('active');
          }
        }
      });
    },
    { rootMargin: '-100px 0px -66%' }
  );

  headings.forEach((heading) => observer.observe(heading));
}
